"use client";

/**
 * The same, for an error in the root layout itself, where nothing of the app
 * can be relied on: plain markup, no components.
 */
export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  return (
    <html lang="pt-PT">
      <body style={{ fontFamily: "Roboto, system-ui, sans-serif", background: "#f4f5f2", color: "#1f2521", margin: 0 }}>
        <div style={{ maxWidth: 420, margin: "20vh auto 0", padding: "0 24px", textAlign: "center" }}>
          <h1 style={{ fontSize: 20, fontWeight: 700 }}>Algo correu mal</h1>
          <p style={{ color: "#5c655f", fontSize: 14 }}>Não conseguimos mostrar esta página. Tenta carregá-la outra vez.</p>
          <p style={{ color: "#8a928d", fontSize: 11 }}>{error.digest || error.message}</p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{ marginTop: 16, border: 0, borderRadius: 999, background: "hsl(142 76% 36%)", color: "#fff", fontWeight: 700, fontSize: 14, padding: "12px 24px", cursor: "pointer" }}
          >
            Recarregar
          </button>
        </div>
      </body>
    </html>
  );
}
